import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {HorizontalTimelineComponent} from "./horizontal-timeline.component";
@NgModule({
    imports: [
        CommonModule
    ],
    declarations: [HorizontalTimelineComponent],

    exports: [HorizontalTimelineComponent]
})
export class HorizontalTimelineModule { }



// WEBPACK FOOTER //
// D:/projects/4164_AppsPotr_Backend/production/CMS_prod/src/app/shared/horizontal-timeline/horizontal-timeline.module.ts